module.exports = __webpack_public_path__ + "img/cb8.739cc245.jpg";